'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const createFormattedActionName = action => () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: `reportingActions.${action}.name`
});